var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntelligentInline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#\u672A\u547D\u540D\u7684\u6E10\u53D8_24);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8_24",
    x1: -119.77,
    y1: 32,
    x2: -119.27,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f08152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fed75c"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "s1_\u667A\u80FD\u5BA1\u65B9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60,0H4A4,4,0,0,0,0,4V60a4,4,0,0,0,4,4H60a4,4,0,0,0,4-4V4A4,4,0,0,0,60,0ZM41.59,50.2a1.33,1.33,0,0,1-1.33,1.33H23.14A1.16,1.16,0,0,1,22,50.37V47.83a1.16,1.16,0,0,1,1.16-1.16H40.43a1.16,1.16,0,0,1,1.16,1.16Zm7.21-7.37a1.32,1.32,0,0,1-1.32,1.32H15.93a1.33,1.33,0,0,1-1.33-1.32V39.29a4.87,4.87,0,0,1,4.87-4.86h7.37V30.58h0a9.68,9.68,0,0,1-3.91-12.52,9.7,9.7,0,0,1,18.49,4.13,9.67,9.67,0,0,1-4.86,8.39h0v3.85h7.38a4.87,4.87,0,0,1,4.86,4.86Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntelligentInline);
export default __webpack_public_path__ + "static/media/IntelligentInline.55d31668.svg";
export { ForwardRef as ReactComponent };